import Image from 'app/Components/Shared/Image/image';
import React, { useEffect, useState } from 'react';
import useExtendedEffect from '../../../../utilities/hooks/useExtendedEffect';
import useEffectAsync from '../../../../utilities/hooks/useEffectAsync';
import { connect } from 'react-redux';
import Config from "../../../../Config";
import SaleFooter from '../Partials/SaleFooter/SaleFooter';
import { goToPage, setEmail, setErrorText, reportDWH, setPersonalInfo } from '../saleJetBlockSlice';
import {dwhThirdPartyConsentCheckboxDisplay} from "../../ChangePricePlanBlock/reports/dwhReports";
import { createSaleAsync, emailIsExist } from '../saleBlockAsyncThunk';
import TextInput from '../../../Shared/TextInput/TextInput';
import CheckBox from '../../../Shared/CheckBox/Checkbox';
import ThirdParty from '../../../Shared/ThirdParty/ThirdParty';
import { gtag4 } from '../../../../utilities/analytics/tracking';
import lightIcon from '../images/light.svg';
import { prepareUrl, prepareNewWindowUrl } from '../../../../utilities/StringHelpers/StringHelpers';

const EmailPage = (props) => {
  const [checkboxIsReceivingBill , setCheckboxIsReceivingBill] = useState(false);
  const [checkboxIsReceivingAd , setCheckboxIsReceivingAd] = useState(false);

  useEffect(() => {
    if (props.showCollaborationApproval){
      dwhThirdPartyConsentCheckboxDisplay(props.userDetails.firstName + " " + props.userDetails.lastName, props.userDetails.contactNumber, props.userDetails.IDNumber, "מכר " + props.saleType)
    }
    props.reportDWH({ actionType: 'Email Page', status: 'Ongoing', messageText: 'Email Page Displayed' });
    gtag4({
      event: props.saleType == 'cellular' ? 'cellular_Step12_EmailInvoicePage' : `${props.saleType}_Step8_SendInvoicePage`,
      step: props.saleType == 'cellular' ? '12' : '8',
      action: 'EmailInvoicePage',
      funnel_name: `${props.saleType}_Exists${props.flowType == 'existsCustomer' ? '_Exists' : '_New'}_Customer`
    });
  }, []);

  //page params
  let isDisplayFooter = true;
  let btnText =  props.saleType == 'cellular' ? 'ממשיכים לסיכום' : 'המשך';
  let currentPageFunction = handlePageContinue;
  let totalPrice = null;
  let priceText = '';
  let formid = 'saleJet';
  //page params

  let title = '';
  let subTitle = "";
  let bottomRemark = "";

  if (props.saleType == 'internet') {
    title = 'אוטוטו מסיימים';
    subTitle = 'מה המייל שלך?';
    bottomRemark = `מייל זה ישמש להתקשרות מול ${window.Config.brand_Name_HE}`;
  }
  else if(props.saleType == 'cellular'){
    title = 'לאיזה מייל לשלוח את החשבונית?'
    subTitle = '';
    bottomRemark = (props.isSelectedEsim ? 'למייל זה יישלחו גם הנחיות להפעלת ה-eSIM' : '');
  }
  else {
    title = 'אוטוטו מסיימים';
    subTitle = `מה המייל שישמש אותך לכניסה ל${window.Config.brand_Name_HE} TV?`;
    bottomRemark = `בסיום ההזמנה נשלח למייל שלך את הסיסמא ל${window.Config.brand_Name_HE} TV`;
  }


  let currentPageHeadline = (
    <div className='page-headline-wrapper'>
      <h1 className='sale-title'></h1>
      <h1 className='sale-title-big'> {title} </h1>
      <h2 className='sale-title-small'> {subTitle} </h2>
    </div>
  );

  let currentPageView = (
    <div className='email-page-sale-jet' style={{ paddingTop: '30px'}}>
      {props.saleType == 'cellular' && bottomRemark && <div className='cellular-bottom-remark'><Image src={lightIcon} alt="" /> {bottomRemark} </div>}
      <div>
        <div className='email-wrapper'>
          {/* <div className='title-container-email'> {Config.receivingAdTitle}</div> */}
          <TextInput placeholder='כתובת מייל' error={props.errorText} required="required" onChange={(e) => { handleInputChange(e.target.value) }} value={props.email} />
          <div className='text-container-email'> {Config.primaryEmailText} <a href="#" onClick={(e) => { e.preventDefault(); prepareNewWindowUrl(Config.primaryEmailMoreInfoUrl,props.context); }} className='link' target="_blank"> {Config.primaryEmailMoreInfoText}</a> </div>
        </div>
        {props.saleType != 'cellular' && <div style={{ fontSize: '14px', color: '#757475',padding : '24px 0px' }}> {bottomRemark} </div> }
        <div className='checkbox-wrapper' >
          {/* <CheckBox
            checked={checkboxIsReceivingBill}
            label='אני רוצה לקבל את החשבונית למייל שהזנתי (במקרה בו תסיר את הסימון, תשלח החשבונית לכתובת המגורים שמילאת)'
            id='isReceivingBill'
            onChange={() => onClickCheckboxIsReceivingBill()} /> */}
          {props.showCollaborationApproval &&
            <div style={{ paddingTop: '8px' }}>
              <CheckBox
              checked={checkboxIsReceivingAd}
              label= {<ThirdParty/>}
              id='isReceivingAd'
              onChange={() => onClickCheckboxIsReceivingAd()}/>
            </div>
          }
        </div>
      </div>
    </div>
  );

  return (
    <div className='slideAnimation'>
      {currentPageHeadline}
      <div className='sale-page-content'>
        <form noValidate id='sale' onSubmit={handleSubmit}>
          {currentPageView}
        </form>
        <SaleFooter isDisplayFooter={isDisplayFooter} btnText={btnText} onclick={currentPageFunction} price={totalPrice} priceText={priceText} formid={formid} />
      </div>
    </div>
  );

  function onClickCheckboxIsReceivingBill() {
    setCheckboxIsReceivingBill(!checkboxIsReceivingBill);
  }

  function onClickCheckboxIsReceivingAd(){
    setCheckboxIsReceivingAd(!checkboxIsReceivingAd);
  }


  function isValidEMail(email) {
    return /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email);
  }

  function handleInputChange(email) {
    props.setEmail(email);
  }

  async function handlePageContinue() {
    if (props.email.trim() == '') {
      props.setErrorText('אנא הכנס כתובת מייל');
    }
    else {
      if (isValidEMail(props.email)) {
        props.setErrorText('');
        if (props.saleType != 'internet' && props.saleType != 'cellular') {
          const isAvailableEmail = await props.emailIsExist({ eMailAddress: props.email, captchaToken: "" });
          if (isAvailableEmail.payload) {
            props.reportDWH({ actionType: 'Email Page', status: 'Ongoing', messageText: 'Email Page Button Clicked' });
            props.setPersonalInfo({  isReceivingBill: checkboxIsReceivingBill, isReceivingAd: checkboxIsReceivingAd });
            props.goToPage('summaryPage');
          }
          else {
            props.setErrorText('קיים כבר מנוי TV על המייל הזה, יש מייל אחר?');
          }
        }
        else {
          props.reportDWH({ actionType: 'Email Page', status: 'Ongoing', messageText: 'Email Page Button Clicked' });
          props.setPersonalInfo({  isReceivingBill: checkboxIsReceivingBill, isReceivingAd: checkboxIsReceivingAd });
          props.goToPage('summaryPage');
        }
      }
      else {
        props.setErrorText('אנא הכנס כתובת מייל תקינה');
      }
    }
    gtag4({
      event: props.saleType == 'cellular' ? 'cellular_Step12_SendInvoiceContinueButton' : `${props.saleType}_Step8_SendInvoiceContinueButton`,
      step: props.saleType == 'cellular' ? '12' : '8',
      button: btnText,
      action: 'SendInvoiceContinueButton',
      funnel_name: `${props.saleType}_Exists${props.flowType == 'existsCustomer' ? '_Exists' : '_New'}_Customer`
    });
  }

  function handleSubmit(event) {
    event.preventDefault();

  }

};

const mapStateToProps = (state) => {
  return {
    saleType: state.saleJetBlock.saleType,
    flowType: state.saleJetBlock.flowType,
    offerName: state.saleJetBlock.offerName,
    email: state.saleJetBlock.personalInfo.email,
    errorText: state.saleJetBlock.errorText,
    isSelectedEsim : state.saleJetBlock.cellular.isSelectedEsim,
    showCollaborationApproval: state.saleJetBlock.checkUserResponse.showCollaborationApproval,
    userDetails: state.authentication.loginData.userDetails


    //other states
  };
};

const mapDispatchToProps = {
  goToPage,
  setEmail,
  createSaleAsync,
  emailIsExist,
  setErrorText,
  reportDWH,
  setPersonalInfo
};

export default connect(mapStateToProps, mapDispatchToProps)(EmailPage);
